import React from "react";

import { Table, TableProps } from "@SeemplicityDev/shared";

export type {
  TableCellType,
  TableCellProps,
  TableProps,
} from "@SeemplicityDev/shared";

export const TypedTable = Table as React.FC<TableProps>;

export type TableDataWithSelector<T> = T & { selector: string };
